export const FETCH_STRUCTURE3D_PROJECTS = 'FETCH_STRUCTURE3D_PROJECTS';
